import React, {PropTypes} from "react";
import {Field, reduxForm} from "redux-form";
import MenuItem from "material-ui/MenuItem";
import {DatePicker, SelectField, TextField} from "redux-form-material-ui";
const validate = values => {
  const errors = {};
  const requiredFields = ['name', 'gender', 'empDOB', 'emailIdPersonal', 'maritalStatus'];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
  });

  if (values.emailIdPersonal && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailIdPersonal)) {
    errors.emailIdPersonal = 'Invalid email address'
  }
  return errors
};
class PersonalInfo extends React.Component {

  constructor() {
    super();
  }

  render() {

    const {handleSubmit, reset} = this.props;
    return (
      <div className="col-md-12">
        <form onSubmit={handleSubmit(data=> {
          console.log(data);
          this.props.submitHandler(data);

        })}>
          <table style={{marginBottom: 0, width: '100%'}} className="table table-bordered">
            <thead>
            <tr>
              <th cellPadding="0" colSpan="4">
                <span className="bold pull-left"> Personal Info</span>

                <span className="bold hrms-link pull-right"><a type="submit">
                     <button type="submit"><i className="glyphicon glyphicon-saved"
                     ></i>Save</button></a></span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td style={{align: 'left', width: '18%'}}>*Name :</td>
              <td style={{align: 'left', width: '28%', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                    <Field
                      name="name"
                      component={TextField}/></span>
              </td>
              <td style={{align: 'left', width: '18%'}}>*Gender :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">
                    <Field
                      name="gender"
                      component={SelectField}>
                     <MenuItem value='M' primaryText='Male'/>
                     <MenuItem value='F' primaryText='Female'/>

                  </Field>
                  </span>
              </td>
            </tr>
            <tr>
              <td style={{align: 'left'}}>*Date of birth :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                    <Field

                      name="empDOB"
                      autoOk={true}
                      component={DatePicker}/>
                  </span>
              </td>
              <td style={{align: 'left'}}>*Email Id Personal:</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblAnniversary" className="GenText"><Field
                    name="emailIdPersonal"
                    autoOk={true}
                    component={TextField}/></span>
              </td>
            </tr>


            <tr>
              <td style={{align: 'left'}}>*Marital Status :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                    <Field
                      name="maritalStatus"
                      component={SelectField}>
                     <MenuItem value='S' primaryText='Single'/>
                     <MenuItem value='M' primaryText='Married'/>
                     <MenuItem value='W' primaryText='Widow'/>
                     <MenuItem value='R' primaryText='Widower'/>

                  </Field></span>
              </td>
              <td style={{align: 'left'}}>Anniversary :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblAnniversary" className="GenText"><Field
                    name="empAnniversary"
                    autoOk={true}
                    component={DatePicker}/></span>
              </td>

            </tr>

            </tbody>
          </table>
        </form>


      </div>
    );
  }
}

PersonalInfo.propTypes = {};

export default reduxForm({
  form: 'personalInfo',
  validate


})(PersonalInfo)






/** WEBPACK FOOTER **
 ** ./src/components/joiningForm/Tables/PersonalInfoEdit.js
 **/